import { Box, Button } from '@chakra-ui/react';
import { ButtonBlockViewProps, BlockItemViewProps } from '../../../../view';
import { ReportingViewBaseConfig } from '../../../../base';

export function createDocumentButtonView(
    config: ReportingViewBaseConfig & {
        BlockItem: React.FC<BlockItemViewProps>;
    }
): React.FC<ButtonBlockViewProps> {
    const { BlockItem } = config;

    return (props) => {
        return (
            <BlockItem {...props.block}>
                <Box as="form" {...props.form.getFormElementProps()}>
                    <Button
                        {...props.button}
                        variant="outline"
                        borderColor="whiteAlpha.200"
                        bg="none"
                        color="whiteAlpha.800"
                        _hover={{ bg: 'whiteAlpha.50' }}
                    >
                        {props.label}
                    </Button>
                </Box>
            </BlockItem>
        );
    };
}
